import { ref } from 'vue'
import { db } from '@src/services/db'
import Kanban from '@src/types/Kanban'

const kanbans = ref<Kanban[]>([])
const loading = ref(false)

export function useKanbans() {

    const loadKanbans = async () => {
        loading.value = true

        const result = await db.kanbans.toArray()

        kanbans.value = result.sort((a, b) => a.order - b.order)

        loading.value = false
    }

    return {
        kanbans,
        loading,
        loadKanbans
    }
}
